var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHeader)?_c('header',{class:_vm.showTopMargin ? 'top-margin' : ''},[(_vm.showProgress)?_c('progress-indicator',{style:(_vm.progressStyleObject)}):_vm._e(),(_vm.showCancelButton)?_c('button',{staticClass:"primaryButton white-outline",on:{"click":_vm.cancelCreation}},[_vm._v("Cancel")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }